document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-oxx-accordion]').forEach(function (accordion) {
    accordion.querySelectorAll('.oxx-accordion-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.oxx-accordion-item');
        if (!item) return;
        var isOpen = item.classList.contains('is-open');
        accordion.querySelectorAll('.oxx-accordion-item').forEach(function (other) {
          other.classList.remove('is-open');
        });
        if (!isOpen) item.classList.add('is-open');
      });
    });
  });

  document.querySelectorAll('[data-oxx-kb-search]').forEach(function (input) {
    input.addEventListener('input', function () {
      var scope = input.closest('.oxx-page-knowledge-base') || document;
      var query = input.value.trim().toLowerCase();
      scope.querySelectorAll('[data-oxx-kb-item]').forEach(function (card) {
        var haystack = (card.getAttribute('data-oxx-kb-item') || '').toLowerCase();
        card.style.display = !query || haystack.indexOf(query) !== -1 ? '' : 'none';
      });
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-oxx-size-calculator]').forEach(function (tool) {
    var idInput = tool.querySelector('[data-field="id"]');
    var csInput = tool.querySelector('[data-field="cs"]');
    var odInput = tool.querySelector('[data-field="od"]');
    var calcBtn = tool.querySelector('[data-action="calculate"]');
    var clearBtn = tool.querySelector('[data-action="clear"]');
    var errorBox = tool.querySelector('[data-error]');
    var resultBox = tool.querySelector('[data-result]');
    var resultId = tool.querySelector('[data-result-id]');
    var resultCs = tool.querySelector('[data-result-cs]');
    var resultOd = tool.querySelector('[data-result-od]');
    var resultFormula = tool.querySelector('[data-result-formula]');
    var searchLink = tool.querySelector('[data-search-link]');
    var quoteLink = tool.querySelector('[data-quote-link]');
    function num(input) {
      var value = parseFloat((input && input.value) || '');
      return Number.isFinite(value) ? value : null;
    }
    function fmt(value) {
      return value === null ? '-' : Number(value).toFixed(2) + ' mm';
    }
    function setError(message) {
      if (!errorBox) return;
      if (!message) {
        errorBox.hidden = true;
        errorBox.textContent = '';
        return;
      }
      errorBox.hidden = false;
      errorBox.textContent = message;
    }
    function setResult(id, cs, od, formula) {
      if (!resultBox) return;
      resultBox.hidden = false;
      if (resultId) resultId.textContent = fmt(id);
      if (resultCs) resultCs.textContent = fmt(cs);
      if (resultOd) resultOd.textContent = fmt(od);
      if (resultFormula) resultFormula.textContent = formula;
      if (searchLink && id !== null && cs !== null) {
        searchLink.href = '/search?q=' + encodeURIComponent(id.toFixed(2) + ' x ' + cs.toFixed(2)) + '&type=product';
      }
      if (quoteLink) {
        var params = new URLSearchParams();
        if (id !== null) params.set('id', id.toFixed(2));
        if (cs !== null) params.set('cs', cs.toFixed(2));
        if (od !== null) params.set('od', od.toFixed(2));
        params.set('source', 'size_guide_calculator');
        quoteLink.href = '/pages/bulk-quote?' + params.toString();
      }
    }
    function calculate() {
      var id = num(idInput);
      var cs = num(csInput);
      var od = num(odInput);
      setError('');
      if (resultBox) resultBox.hidden = true;
      if (cs === null || cs <= 0) {
        setError('Enter a valid cross section (CS) in mm first.');
        return;
      }
      if (id !== null && od === null) {
        od = id + (2 * cs);
        if (odInput) odInput.value = od.toFixed(2);
        setResult(id, cs, od, 'Calculated OD from ID + (2 x CS).');
        return;
      }
      if (od !== null && id === null) {
        id = od - (2 * cs);
        if (id <= 0) {
          setError('OD must be larger than 2 x CS to calculate a valid ID.');
          return;
        }
        if (idInput) idInput.value = id.toFixed(2);
        setResult(id, cs, od, 'Calculated ID from OD - (2 x CS).');
        return;
      }
      if (id !== null && od !== null) {
        setResult(id, cs, od, 'Showing the values you entered. Search uses ID x CS.');
        return;
      }
      setError('Enter ID + CS or OD + CS to calculate the missing size.');
    }
    function clearAll() {
      [idInput, csInput, odInput].forEach(function (input) { if (input) input.value = ''; });
      setError('');
      if (resultBox) resultBox.hidden = true;
    }
    if (calcBtn) calcBtn.addEventListener('click', calculate);
    if (clearBtn) clearBtn.addEventListener('click', clearAll);
  });

  document.querySelectorAll('[data-oxx-material-selector]').forEach(function (tool) {
    var options = tool.querySelectorAll('.oxx-material-selector__option');
    var result = tool.querySelector('[data-result]');
    var title = tool.querySelector('[data-rec-title]');
    var good = tool.querySelector('[data-rec-good]');
    var also = tool.querySelector('[data-rec-also]');
    var avoid = tool.querySelector('[data-rec-avoid]');
    var shopLink = tool.querySelector('[data-shop-link]');
    var compareLink = tool.querySelector('[data-compare-link]');
    var map = {
      oil: {
        title: 'Recommended: NBR',
        good: 'Good for: general oil, grease, and everyday sealing.',
        also: 'Also consider: FKM for higher heat or fuel exposure.',
        avoid: 'Avoid: EPDM for oil and fuel.',
        shop: '/collections/nbr'
      },
      fuel: {
        title: 'Recommended: FKM',
        good: 'Good for: fuel, gasoline, oil, and heat.',
        also: 'Also consider: NBR for general oil.',
        avoid: 'Avoid: EPDM for fuel and oil.',
        shop: '/collections/fkm'
      },
      water: {
        title: 'Recommended: EPDM',
        good: 'Good for: water, weather, and outdoor sealing.',
        also: 'Also consider: Silicone for flexible or clean applications.',
        avoid: 'Avoid: NBR for long outdoor exposure.',
        shop: '/collections/epdm'
      },
      steam: {
        title: 'Recommended: EPDM',
        good: 'Good for: hot water and steam-related sealing.',
        also: 'Also consider: FKM only for some heat and oil cases.',
        avoid: 'Avoid: NBR for steam.',
        shop: '/collections/epdm'
      },
      heat: {
        title: 'Recommended: FKM',
        good: 'Good for: heat, oil, and fuel-related environments.',
        also: 'Also consider: Silicone for dry heat or flexibility, and FFKM for extreme chemical and heat cases.',
        avoid: 'Avoid: NBR for high heat.',
        shop: '/collections/fkm'
      },
      food: {
        title: 'Recommended: Silicone',
        good: 'Good for: flexible, clean, and general food-contact style applications.',
        also: 'Also consider: EPDM for water or outdoor conditions.',
        avoid: 'Avoid: FKM unless the application requires fuel, oil, or heat resistance.',
        shop: '/collections/silicone'
      },
      unknown: {
        title: 'Recommended: Ask before ordering',
        good: 'Good for: unclear material, chemical, temperature, or size conditions.',
        also: 'Also consider: sending a photo, sketch, or old O-ring size.',
        avoid: 'Avoid: guessing when fuel, steam, chemicals, or high heat are involved.',
        shop: '/pages/bulk-quote'
      }
    };
    options.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var choice = btn.getAttribute('data-choice');
        var data = map[choice];
        if (!data) return;
        options.forEach(function (other) { other.classList.remove('is-active'); });
        btn.classList.add('is-active');
        if (result) result.hidden = false;
        if (title) title.textContent = data.title;
        if (good) good.textContent = data.good;
        if (also) also.textContent = data.also;
        if (avoid) avoid.textContent = data.avoid;
        if (shopLink) {
          shopLink.href = data.shop;
          shopLink.querySelector('span:last-child').textContent = choice === 'unknown' ? 'Ask before ordering' : 'Shop recommended material';
        }
        if (compareLink) {
          compareLink.href = '/blogs/knowledge-base/nbr-vs-fkm-o-rings-oil-fuel-heat-guide';
        }
      });
    });
  });
});
